/**
 * Mighty Mug — Mobile Product Image Carousel
 * 
 * Reads images from the existing .product-media--thumb-container elements,
 * builds a Swiper carousel for mobile, and updates it when a color swatch
 * is selected.
 */

(function() {
  'use strict';

  // Only run on product pages
  if (!document.querySelector('.product-page--root')) return;

  // Wait for DOM and Swiper to be ready
  function init() {
    if (typeof Swiper === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    var mediaSection = document.querySelector('.product-page--media');
    if (!mediaSection) return;

    // Create the carousel container
    var carousel = document.createElement('div');
    carousel.className = 'mm-mobile-carousel';
    carousel.innerHTML =
      '<div class="swiper mm-product-swiper">' +
        '<div class="swiper-wrapper"></div>' +
        '<div class="swiper-pagination"></div>' +
        '<div class="swiper-button-prev"></div>' +
        '<div class="swiper-button-next"></div>' +
      '</div>';

    // Insert the carousel inside the media section, before the existing wrapper
    var existingWrapper = mediaSection.querySelector('.product-media--wrapper');
    if (existingWrapper) {
      mediaSection.insertBefore(carousel, existingWrapper);
    } else {
      mediaSection.appendChild(carousel);
    }

    var swiperInstance = null;

    /**
     * Get the currently visible images from the thumb containers.
     * The theme already handles showing/hiding thumbs via mm-hidden class
     * based on the selected variant — we just read what's visible.
     */
    function getVisibleImages() {
      var thumbs = document.querySelectorAll('.product-media--thumb-container');
      var images = [];

      for (var i = 0; i < thumbs.length; i++) {
        var thumb = thumbs[i];
        var hiddenChild = thumb.querySelector('.mm-hidden');
        
        // Skip if this thumb's inner element has mm-hidden class
        if (hiddenChild) continue;

        var img = thumb.querySelector('img');
        if (!img) continue;

        // Get the full-size image URL (not the thumbnail)
        var src = img.getAttribute('data-src') || img.getAttribute('src') || '';
        if (!src) continue;

        // Convert thumbnail URL to larger size
        // Replace _small, _compact, _medium, _100x, etc. with _1024x1024
        src = src.replace(/_(?:small|compact|medium|large|\d+x\d+|x\d+|\d+x)(?=\.\w+)/i, '_1024x1024');
        
        // If no size modifier found, try to add one before the extension
        if (src.indexOf('_1024x1024') === -1) {
          src = src.replace(/(\.\w+)(\?|$)/, '_1024x1024$1$2');
        }

        // Ensure protocol
        if (src.indexOf('//') === 0) {
          src = 'https:' + src;
        }

        var alt = img.getAttribute('alt') || 'Product image';
        images.push({ src: src, alt: alt });
      }

      // Fallback: if no thumbs are visible, grab from the main media items
      if (images.length === 0) {
        var mediaItems = document.querySelectorAll('.product-media-item:not(.mm-hidden)');
        for (var j = 0; j < mediaItems.length; j++) {
          var mImg = mediaItems[j].querySelector('img');
          if (mImg) {
            var mSrc = mImg.getAttribute('data-src') || mImg.getAttribute('src') || '';
            if (mSrc.indexOf('//') === 0) mSrc = 'https:' + mSrc;
            images.push({ src: mSrc, alt: mImg.getAttribute('alt') || 'Product image' });
          }
          // Limit fallback to first 7 images
          if (images.length >= 7) break;
        }
      }

      return images;
    }

    /**
     * Build or rebuild the Swiper carousel with the given images.
     */
    function buildCarousel() {
      var images = getVisibleImages();
      var wrapper = carousel.querySelector('.swiper-wrapper');

      // Clear existing slides
      wrapper.innerHTML = '';

      // Create slides
      for (var i = 0; i < images.length; i++) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        var imgEl = document.createElement('img');
        imgEl.setAttribute('src', images[i].src);
        imgEl.setAttribute('alt', images[i].alt);
        imgEl.setAttribute('loading', i === 0 ? 'eager' : 'lazy');
        slide.appendChild(imgEl);
        wrapper.appendChild(slide);
      }

      // Destroy existing Swiper instance if it exists
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }

      // Initialize Swiper
      if (images.length > 0) {
        swiperInstance = new Swiper('.mm-product-swiper', {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: images.length > 1,
          pagination: {
            el: '.mm-mobile-carousel .swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.mm-mobile-carousel .swiper-button-next',
            prevEl: '.mm-mobile-carousel .swiper-button-prev'
          },
          // Enable touch/swipe
          touchEventsTarget: 'container',
          grabCursor: true,
          // Accessibility
          a11y: {
            prevSlideMessage: 'Previous image',
            nextSlideMessage: 'Next image',
            paginationBulletMessage: 'Go to image {{index}}'
          }
        });
      }
    }

    // Initial build
    buildCarousel();

    /**
     * Listen for variant/color changes.
     * The theme uses .mm-color-swatch elements with click handlers
     * that add/remove .mm-hidden on thumbnail containers.
     * We observe those changes and rebuild the carousel.
     */
    var thumbsContainer = document.querySelector('.product-page--thumbs');
    if (thumbsContainer) {
      var observer = new MutationObserver(function(mutations) {
        // Debounce: wait a tick for the theme's JS to finish toggling classes
        clearTimeout(observer._timeout);
        observer._timeout = setTimeout(function() {
          buildCarousel();
        }, 150);
      });

      observer.observe(thumbsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    // Also listen for swatch clicks directly as a backup
    var swatches = document.querySelectorAll('.mm-color-swatch');
    for (var k = 0; k < swatches.length; k++) {
      swatches[k].addEventListener('click', function() {
        // Give the theme's JS time to update the thumbs
        setTimeout(buildCarousel, 300);
      });
    }

    // Also listen for size selector changes (12oz vs 16oz)
    var sizeButtons = document.querySelectorAll('.product-page--cart-form .mm-size-option, .product-page--cart-form [data-size]');
    for (var s = 0; s < sizeButtons.length; s++) {
      sizeButtons[s].addEventListener('click', function() {
        setTimeout(buildCarousel, 300);
      });
    }
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/**
 * Mighty Mug — Move Loox Reviews to Full Width
 *
 * The Loox app auto-injects its reviews widget inside the product
 * description column, which is only ~325px wide on desktop.
 * This script moves it to a full-width container below the product section.
 */
(function() {
  'use strict';

  function moveLooxReviews() {
    var looxReviews = document.getElementById('looxReviews');
    if (!looxReviews) return false;

    // Don't move if already moved
    if (looxReviews.parentElement && looxReviews.parentElement.classList.contains('mm-loox-fullwidth')) {
      return true;
    }

    // Find the product section to insert after
    var productSection = document.querySelector('.section--products');
    if (!productSection) return false;

    // Create a full-width wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'mm-loox-fullwidth';

    // Move the loox reviews into the wrapper
    wrapper.appendChild(looxReviews);

    // Insert the wrapper after the product section
    productSection.parentNode.insertBefore(wrapper, productSection.nextSibling);

    return true;
  }

  // The Loox widget loads asynchronously, so we need to wait for it
  var attempts = 0;
  var maxAttempts = 50; // Try for up to 10 seconds

  function tryMove() {
    if (moveLooxReviews()) return;
    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(tryMove, 200);
    }
  }

  // Start checking when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryMove);
  } else {
    tryMove();
  }
})();